import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';
import { initYaMaps } from 'vpl.tas';


export const Contacts = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    methods: {
        clearPhone(phone) {
            phone = phone.replace(/[^0-9+]/g, '');
            return 'tel:' + phone;
        },
        whaLink(phone) {
            phone = phone.replace(/[^0-9]/g, '');
            return 'https://wa.me/' + phone;
        }
    },
    updated() {

    },
    mounted() {

        let self = this;

        $(this.$el).find('[data-fancybox]').fancybox({
            loop: true
        });

        let markers = [];
        let data = [];

        for (let j in this.struct[this.structKey].componentData.ITEMS) {
            for (let i in this.struct[this.structKey].componentData.ITEMS[j]) {
                let item = this.struct[this.structKey].componentData.ITEMS[j][i];
                let coord = item.MAP.split(',');

                markers.push(coord);

                let picture = false;
                if (item.GALLERY && item.GALLERY.length) {
                    picture = item.GALLERY[0].BALOON;
                }
                data.push({
                    "NAME": item.NAME,
                    "PROPERTY_ADDRESS_VALUE": item.ADDRESS,
                    "PROPERTY_PHONE_VALUE": item.PHONE,
                    "PROPERTY_MAIL_VALUE": item.EMAIL,
                    "PROPERTY_TIME_VALUE": item.SCHEDULE,
                    "PROPERTY_IMG_VALUE": picture,
                    "ID": item.ID
                });

            }
        }

        initYaMaps();

        var mapHeight = $('#map').height();

        let interval = setInterval(()=>{
            if(typeof ymaps !== "undefined"){

                ymaps.ready(function () {

                    var contactsMap = new ymaps.Map("map", {
                        center: ['54.924961', '37.463790'],
                        zoom: 15,
                        behaviors: ['default'],
                        controls: []
                    }),
                        MyIconContentLayout = ymaps.templateLayoutFactory.createClass(
                            '<span style="font-weight: 600;font-size: 18px; color: #000">{{ properties.geoObjects.length }}</span>'
                        ),

                        objectManager = new ymaps.ObjectManager({
                            clusterize: true,
                            clusterIcons: [
                                {
                                    href: self.SITE_TEMPLATE_PATH + '/img/svg/claster-small.svg',
                                    size: [40, 40],
                                    offset: [-27.5, -42],
                                    iconContentOffset: [23, 15],
                                },
                                {
                                    href: self.SITE_TEMPLATE_PATH + '/img/svg/claster-small.svg',
                                    size: [55, 55],
                                    offset: [-27.5, -42],
                                    iconContentOffset: [25, 25],
                                }],
                            clusterNumbers: [3],
                            clusterIconContentLayout: MyIconContentLayout
                        });


                    var MyBalloonLayout = ymaps.templateLayoutFactory.createClass(
                        '<div class="popover">' +
                        '<div class="popover__arrow"></div>' +
                        '<div class="popover__inner">' +
                        '<a class="popover__close" href="#">' +
                        '<svg class="icon icon-close">' +
                        '<use xlink:href="#icon-close"></use>' +
                        '</svg>' +
                        '</a>' +
                        '$[[options.contentLayout observeSize minWidth=400 maxWidth=400]]' +
                        '<span class="popover__tail"></span>' +
                        '</div>' +
                        '</div>', {
                        build: function () {
                            this.constructor.superclass.build.call(this);

                            this._$element = $('.popover', this.getParentElement());

                            this.applyElementOffset();

                            this._$element.find('.popover__close')
                                .on('click', $.proxy(this.onCloseClick, this));
                        },
                        clear: function () {
                            this._$element.find('.popover__close')
                                .off('click');

                            this.constructor.superclass.clear.call(this);
                        },
                        onSublayoutSizeChange: function () {
                            MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                            if (!this._isElement(this._$element)) {
                                return;
                            }

                            this.applyElementOffset();

                            this.events.fire('shapechange');
                        },
                        applyElementOffset: function () {
                            this._$element.css({
                                left: -(this._$element[0].offsetWidth / 2.3),
                                top: -(this._$element[0].offsetHeight + this._$element.find('.popover__arrow')[0].offsetHeight - 10)
                            });
                        },
                        onCloseClick: function (e) {
                            e.preventDefault();

                            this.events.fire('userclose');
                        },
                        getShape: function () {
                            if (!this._isElement(this._$element)) {
                                return MyBalloonLayout.superclass.getShape.call(this);
                            }

                            var position = this._$element.position();

                            return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                                [position.left, position.top], [
                                    position.left + this._$element[0].offsetWidth,
                                    position.top + this._$element[0].offsetHeight + this._$element.find('.popover__arrow')[0].offsetHeight
                                ]
                            ]));
                        },
                        _isElement: function (element) {
                            return element && element[0] && element.find('.popover__arrow')[0];
                        }
                    });

                    var MyBalloonContentLayout = ymaps.templateLayoutFactory.createClass(
                        '<div class="popover__content">$[properties.balloonContent]</div>'
                    );

                    contactsMap.behaviors.disable(['scrollZoom']);

                    var collection = {
                        type: "FeatureCollection",
                        features: []
                    };

                    for (var i = 0; i < markers.length; i++) {
                        var marker = markers[i];
                        var item = data[i];
                        var phones = '';

                        if (Array.isArray(data[i].PROPERTY_PHONE_VALUE)) {
                            data[i].PROPERTY_PHONE_VALUE.forEach(item => {
                                phones += `<a href="tel:${item.replace(/[^0-9+]/g, '')}">${item}</a>`
                            });
                        } else {
                            phones = `<a href="tel:${data[i].PROPERTY_PHONE_VALUE.replace(/[^0-9+]/g, '')}">${data[i].PROPERTY_PHONE_VALUE}</a>`
                        }

                        var balloon = `
                        <div class="ballon">
                                <div class="ballon__head">
                                <div class="baloon__head-text">
                                    ${data[i].NAME}
                                </div>
                            </div>
                            <div class="baloon__body">
                                    <div class="baloon__img" style="${data[i].PROPERTY_IMG_VALUE ? '' : 'display:none'}">
                                        <img src="${data[i].PROPERTY_IMG_VALUE ? data[i].PROPERTY_IMG_VALUE : self.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'}" alt="${data[i].NAME}" title="${data[i].NAME}">
                                    </div>
                                <div class="baloon__props">

                                    <div style="${data[i].PROPERTY_PHONE_VALUE ? '' : 'display:none'}" class="baloon__line">
                                        <svg class="ico ico-map-tel" width="21" height="20" aria-hidden="true"><use xlink:href="#ico-map-tel"></use></svg>
                                        <div class="baloon__line-list">
                                            ${phones}
                                        </div>
                                    </div>
                                    <div style="${data[i].PROPERTY_MAIL_VALUE ? '' : 'display:none'}" class="baloon__line">
                                        <svg class="ico ico-map-mail" width="21" height="20" aria-hidden="true"><use xlink:href="#ico-map-mail"></use></svg>
                                            <a href="mailto:${item.PROPERTY_MAIL_VALUE}">${item.PROPERTY_MAIL_VALUE}</a>
                                    </div>
                                    <div style="${data[i].PROPERTY_TIME_VALUE ? '' : 'display:none'}" class="baloon__line">
                                        <svg class="ico ico-map-time" width="21" height="20" aria-hidden="true"><use xlink:href="#ico-map-time"></use></svg>
                                        <span>${item.PROPERTY_TIME_VALUE}</span>
                                    </div>
                                    <div style="${data[i].PROPERTY_ADDRESS_VALUE ? '' : 'display:none'}" class="baloon__line">
                                        <svg class="ico ico-map-location" width="21" height="20" aria-hidden="true"><use xlink:href="#ico-map-location"></use></svg>
                                        <span>${item.PROPERTY_ADDRESS_VALUE}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        `;

                        collection.features.push({
                            type: 'Feature',
                            id: i,
                            geometry: {
                                type: 'Point',
                                coordinates: marker,
                                options: {
                                    pixelRendering: "static"
                                }
                            },
                            properties: {
                                balloonContent: balloon,
                                hintContent: item.NAME,
                            },
                            options: {
                                balloonLayout: MyBalloonLayout,
                                balloonContentLayout: MyBalloonContentLayout,
                                balloonOffset: [130, 0],
                                iconColor: '#CE6B33',
                                iconLayout: 'default#image',
                                iconImageHref: self.SITE_TEMPLATE_PATH + '/img/svg/metka.svg',
                                iconImageSize: [44, 53],
                                iconImageOffset: [-22, -53],
                                iconContentOffset: [0, 0],
                            }
                        }
                        )
                    }

                    function onObjectEvent(e) {
                        var objectId = e.get('objectId');
                        if (e.get('type') == 'mouseenter') {
                            objectManager.objects.setObjectOptions(objectId, {
                                iconImageHref: self.SITE_TEMPLATE_PATH + '/img/svg/metka-h.svg'
                            });
                        } else {
                            objectManager.objects.setObjectOptions(objectId, {
                                iconImageHref: self.SITE_TEMPLATE_PATH + '/img/svg/metka.svg'
                            });
                        }
                    };

                    objectManager.add(collection)

                    contactsMap.geoObjects.add(objectManager);
                    objectManager.objects.events.add(['mouseenter', 'mouseleave'], onObjectEvent);

                    let right = '45px';
                    if ($(window).width() <= 768)
                        right = '15px';

                    contactsMap.controls.add('zoomControl', {
                        size: 'small',
                        float: 'none',
                        position: {
                            top: mapHeight / 2 - 30,
                            right: right
                        }
                    });

                    let zoomMargin = 100;
                    if ($(window).width() <= 768)
                        zoomMargin = 10;

                    contactsMap.setBounds(contactsMap.geoObjects.getBounds(),
                        { checkZoomRange: true, zoomMargin: zoomMargin }).then(function () { if (contactsMap.getZoom() > 16) contactsMap.setZoom(16); });
                });

                clearInterval(interval);
            }
        }, 500);
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    /*
     'ID'=>$arItem['ID'],
        'NAME'=>$arItem['NAME'],
        'GALLERY'=>$gallery,
        'PHONE'=>$arItem['PROPERTIES']['GALLERY']['VALUE'],
        'WHATSAPP'=>$arItem['PROPERTIES']['GALLERY']['VALUE'],
        'TELEGRAM'=>$arItem['PROPERTIES']['GALLERY']['VALUE'],
        'EMAIL'=>$arItem['PROPERTIES']['GALLERY']['VALUE'],
        'ADDRESS'=>$arItem['PROPERTIES']['GALLERY']['VALUE'],
        'MAP'=>$arItem['PROPERTIES']['GALLERY']['VALUE']
    */
    template: `
<div>
    <section class="contacts-page">
        <div class="contacts__map" id="map">
        </div>
    </section>
    <section class="section section--smallpadding">
        <div class="container">
            <div class="contacts__list">
                <div class="contacts__block" v-for="(items, key) in this.struct[this.structKey].componentData.ITEMS">
                    <h2 class="contacts__block-title">{{key}}</h2>
                    <div v-for="item in items" class="contacts__list-item">
                        <div class="contacts__list-item-main">
                            <div class="contacts__list-item-name">
                                {{item.NAME}}
                            </div>
                        </div>
                        <div class="contacts__list-item-actions">
                            <div class="contacts__list-item-actions-top">

                                    <div class="contacts__list-item-location">
                                        {{item.ADDRESS}}
                                    </div>
                                <div class="contacts__list-item-actions-top-leftside">
                                    <a v-if="item.PHONE" :href="clearPhone(item.PHONE)" class="contacts__list-item-actions-tel js-copyphone">
                                        <svg class="ico ico-ct-phone" width="20" height="20" aria-hidden="true"><use xlink:href="#ico-ct-phone"></use></svg>
                                        {{item.PHONE}}
                                    </a>
                                    <a v-if="item.EMAIL" :href="'mailto:' + item.EMAIL" class="contacts__list-item-mail-link js-copymail">
                                        <svg class="ico ico-ct-email" width="20" height="20" aria-hidden="true"><use xlink:href="#ico-ct-email"></use></svg>
                                        {{item.EMAIL}}
                                    </a>
                                    <div class="contacts__list-item-actions-wp">
                                        <a v-if="item.WHATSAPP" :href="whaLink(item.WHATSAPP)" target="_blank" rel="nofollow" class="contacts__list-item-actions-soc">
                                            <svg class="icon icon-wa2"><use xlink:href="#icon-wa2"></use></svg>
                                        </a>
                                        <a v-if="item.TELEGRAM" :href="'https://t.me/' + item.TELEGRAM" target="_blank" rel="nofollow" class="contacts__list-item-actions-soc">
                                            <svg class="icon icon-tg"><use xlink:href="#icon-tg"></use></svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="item.SCHEDULE" class="contacts__list-item-actions-time">
                            <span>Режим работы:</span>
                            {{item.SCHEDULE}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
    `
}